import { EventEmitter, Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root',
})
export class ImageService {
    fullResumeEvent: EventEmitter<string | undefined> = new EventEmitter();
    constructor() {
    }
}